import type { BadgeProps } from 'rizzui';

const map: Record<string, NonNullable<BadgeProps['color']>> = {
    info: 'info',
    primary: 'primary',
    success: 'success',
    warning: 'warning',
    danger: 'danger',
    gray: 'secondary',
};

export function stageBadgeColor(stageColor: string): NonNullable<BadgeProps['color']> {
    return map[stageColor] ?? 'secondary';
}
